import { ActivatedRouteSnapshot } from "@angular/router";

export function getFriendlyUrlFromRoute(
  route: ActivatedRouteSnapshot,
): string | null {
  let current: ActivatedRouteSnapshot | null = route;
  while (current) {
    const value = current.paramMap.get("friendly-name");
    if (value) {
      return value;
    }
    current = current.parent;
  }
  return null;
}
